import { render, staticRenderFns } from "./ProPlan.vue?vue&type=template&id=18452f1c&scoped=true&"
import script from "./ProPlan.vue?vue&type=script&lang=js&"
export * from "./ProPlan.vue?vue&type=script&lang=js&"
import style0 from "./ProPlan.vue?vue&type=style&index=0&id=18452f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18452f1c",
  null
  
)

export default component.exports